import { useMemo } from "react";
import { headCountRangeLabels } from "@/utils/ranges.util";
import type { CompanyRangeDto } from "@advanced-sales-technologies/backend-client/models/CompanyRangeDto";
import { useTranslation } from "react-i18next";

import Badge from "@/components/atoms/Badge";

type Props = { showTitle?: boolean } & CompanyRangeDto;

const getHeadcountBadgeColor = (from?: number | null) => {
  if (!from) return "natural";

  if (from <= 10) return "primary";
  if (from <= 50) return "secondary";
  if (from <= 200) return "success";
  if (from <= 500) return "warning";
  if (from <= 1000) return "error";
  if (from <= 5000) return "natural";
  if (from <= 10000) return "primary";

  return "secondary";
};

const HeadcountRangeBadge = ({ from, to, showTitle = false }: Props) => {
  const { t } = useTranslation();
  if (!from && !to) return null;

  const label = useMemo(() => headCountRangeLabels(from, to), [from, to]);
  const color = useMemo(() => getHeadcountBadgeColor(from), [from]);
  return <Badge color={color} label={`${label} ${showTitle ? t("company.detail.employees") : ""}`} size={"sm"} />;
};

export default HeadcountRangeBadge;
